export default {
  filters: {
    managers: {
      placeholder: 'Gestores de ventas',
    },
  },
  metrics: {
    collected_commission: 'Comisión total',
  },
  fields: {
    manager: 'Gestor',
    area: 'Ubicación',
    total_amount: 'Ganancias',
    companies_live: 'Activo',
    restaurant: 'Restaurante',
    live_from: 'Activo desde',
    plan_amount: 'Importe del plan',
    prepayment_bonus_amount: 'Bono de prepago',
    lead_source_bonus_amount: 'Bono de origen de lead',
    google_business_bonus_amount: 'Bono de conexión Google Business',
    promo_code_bonus_amount: 'Bono de código promocional maestro',
    smart_pricing_bonus_amount: 'Bono de precios inteligentes',
    mobile_app_bonus_amount: 'Bono de app móvil',
    sales_goal_bonus_amount: 'Bono de objetivo de ventas',
  },
  buttons: {
    export: 'Exportar',
  },
  toasts: {
    failed_to_load_data: 'Error al cargar los datos',
  },
};
